// Utility to generate consistent colors based on a string (e.g., Obra ID or Name)

export const generateColor = (str: string): { bg: string; text: string; border: string } => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    // Generate HSL color
    // Hue: Use the hash to pick a hue 0-360
    const h = Math.abs(hash % 360);
    // Saturation: Keep it relatively high for vibrant colors (60-80%)
    const s = 70 + (Math.abs(hash % 20));
    // Lightness: Keep it high for pastel background (85-95%)
    const l = 90 + (Math.abs(hash % 10));

    const bg = `hsl(${h}, ${s}%, ${l}%)`;

    // Generate a darker border/text from the same hue
    const borderL = l - 40; // Significantly darker for border
    const textL = l - 60;   // Very dark for text

    const border = `hsl(${h}, ${s}%, ${borderL}%)`;
    const text = `hsl(${h}, ${s}%, ${textL}%)`;

    return { bg, text, border };
};
